import { Injectable } from '@angular/core';

@Injectable()
export class GlobalVariables {
     userToken: string = '';
     User: any = [];
     CanWrite = false;
     IsLoaderOn = true;
     auditTrailId: string = '0';
     auditTrailClass: string = '';
     RolesList: any;
     IsAdmin = false;
     IsTQApprover = false;
     IsEngTeam = false;
     IsTQLeader = false;
     userGPN:string= '';
     userName:string='';
     // IsUploader = false;

     loading = false;
     CurrentRole: string='';
     EmailPattern =
          '^[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]{3}|[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+.[a-zA-Z0-9]{2}$';
     IsAuditVisible = false;
     CurrentYear: Number = new Date().getFullYear();
     pageIndex = 0;
     length = 0;
     totalPage = 0;
     RecordSize = 10;
     IsConsent: boolean=false;
     SecondaryHeadBtnVisible = false;
     //new added

     ShowAlert(msg: string) {
          alert(msg);
     }

      containsSpecialChars(str:any) {
          const specialChars = /[<>()!@#$%^&*_+=:;"'?\/]/;
          return specialChars.test(str);
        }
        
}
